import { render, staticRenderFns } from "./form_detail_change_state_user_component.vue?vue&type=template&id=6a8b90d4&scoped=true"
import script from "./form_detail_change_state_user_component.vue?vue&type=script&lang=js"
export * from "./form_detail_change_state_user_component.vue?vue&type=script&lang=js"
import style0 from "./form_detail_change_state_user_component.vue?vue&type=style&index=0&id=6a8b90d4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8b90d4",
  null
  
)

export default component.exports